import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';

import { extractCompilerErrors, type ErrorResponse } from '../utils';
import { CombinedErrorInternalObject } from '../xstate/prostudio.api-service.types';
import { BotCompilerError, BotCompilerErrorMsg } from './validate-csv';

export const normalizeCompilerErrors = (
  errors: BotCompilerError[]
): BotCompilerError[] => {
  return (
    errors?.map(({ err_msgs, ...rest }) => {
      return {
        ...rest,
        err_msgs: err_msgs

          .map(({ error_description, field_name }) => {
            return error_description ? { error_description, field_name } : null;
          })
          .filter(Boolean) as BotCompilerErrorMsg[],
      };
    }) || []
  );
};

export const validateVersion = async ({
  projectId,
  customerId,
  botName,
  draftVersion,
}: {
  projectId: string;
  customerId: string;
  botName: string;
  draftVersion: string;
}): Promise<BotCompilerError[]> => {
  const botId = `${customerId}.${botName}`;
  const versionId = `${botId}.${draftVersion}`;
  let errors: BotCompilerError[] | null = [];

  const { data: _data, error: validateError } = await urqlGql.validateVersion({
    versionId,
    projectId,
  });

  if (validateError) {
    const errorResBody = (
      validateError.graphQLErrors[0]?.extensions
        ?.internal as CombinedErrorInternalObject & {
        response: {
          body: ErrorResponse;
        };
      }
    )?.response.body;

    const compilerErrors = extractCompilerErrors(errorResBody);

    errors = normalizeCompilerErrors(compilerErrors || []);

    if (!errors) {
      const normalizedErrors = Array.isArray(errorResBody.messages)
        ? errorResBody.messages
        : [errorResBody.messages];

      errors = normalizedErrors.map((error) => ({
        row_num: null,
        row_index: null,
        node_num: null,
        node_index: null,
        cell_num: null,
        cell_index: null,
        err_msgs: [
          {
            error_description: error,
          },
        ],
      }));
    }
  }

  return errors;
};
